import {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
} from "react";

type SelectedBtnState = {
  [key: string]: boolean;
  "1": boolean;
  "2": boolean;
  "3": boolean;
  "4": boolean;
}


interface SegmentReFetchContextType {
  data: any[];
  setData: Dispatch<SetStateAction<any[]>>;
  selectedBtn:SelectedBtnState;
  setSelectedBtn: Dispatch<SetStateAction<SelectedBtnState>>;
  selectedSession: any;
  setSelectedSession:Dispatch<SetStateAction<any>>;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  subject?: number;
  setSubject?: Dispatch<SetStateAction<number>>;
}

export const segmentReFetchContext = createContext<
  SegmentReFetchContextType | undefined
>(undefined);

export const useSegmentReFetch = () => {
  const context = useContext(segmentReFetchContext);
  if (context === undefined) {
    throw new Error("useSegmentReFetch must be used within a StateProvider");
  }
  return context;
};
